module.exports = __webpack_public_path__ + "static/media/ar-camera.04a5c80d.svg";